import type { Id } from '@/convex/_generated/dataModel';
import { isConnectorCatalogExcluded } from '@/lib/connector-catalog-exclusions';
import type { OrgChatSelectedConnector } from './org-chat-types';

export type ComposerConnectorOption = OrgChatSelectedConnector & {
  logoUrl?: string;
  description?: string;
};

type CatalogCard = {
  toolkitSlug: string;
  label: string;
  category?: string;
  available?: boolean;
  connected: boolean;
  connectedAccountId?: Id<'composioConnectedAccounts'>;
  providerAccountLabel?: string;
  providerAccountEmail?: string;
  logoUrl?: string;
  description?: string;
};

export function toComposerConnectorOption(
  card: CatalogCard
): ComposerConnectorOption {
  const shared = {
    toolkitSlug: card.toolkitSlug,
    label: card.label,
    category: card.category,
    available: card.available,
    ...(card.description ? { description: card.description } : {}),
    ...(card.logoUrl ? { logoUrl: card.logoUrl } : {}),
    ...(card.providerAccountLabel
      ? { providerAccountLabel: card.providerAccountLabel }
      : {}),
    ...(card.providerAccountEmail
      ? { providerAccountEmail: card.providerAccountEmail }
      : {}),
  };
  return card.connected && card.connectedAccountId
    ? {
        ...shared,
        connected: true,
        connectedAccountId: card.connectedAccountId,
      }
    : {
        ...shared,
        connected: false,
        ...(card.connectedAccountId
          ? { connectedAccountId: card.connectedAccountId }
          : {}),
      };
}

export function toVisibleComposerConnectorOptions(
  cards: CatalogCard[]
): ComposerConnectorOption[] {
  return cards
    .filter((card) => !isConnectorCatalogExcluded(card))
    .map(toComposerConnectorOption);
}

/** Catalog presentation metadata is not part of persisted connector selection. */
export function toConnectorSelection(
  option: ComposerConnectorOption
): OrgChatSelectedConnector {
  const shared = {
    toolkitSlug: option.toolkitSlug,
    label: option.label,
    ...(option.available !== undefined ? { available: option.available } : {}),
    ...(option.providerAccountLabel
      ? { providerAccountLabel: option.providerAccountLabel }
      : {}),
    ...(option.providerAccountEmail
      ? { providerAccountEmail: option.providerAccountEmail }
      : {}),
  };
  return option.connected
    ? {
        ...shared,
        connected: true,
        connectedAccountId: option.connectedAccountId,
      }
    : {
        ...shared,
        connected: false,
        ...(option.connectedAccountId
          ? { connectedAccountId: option.connectedAccountId }
          : {}),
      };
}
